__turbopack_context__.v({
  "accordionBox": "LinkedAssetsAccordion-module__e-s_Ka__accordionBox",
  "accordionTitle": "LinkedAssetsAccordion-module__e-s_Ka__accordionTitle",
});
